import { axiosInstance } from "./axiosInstance";

export function getPublicKey() {
  return axiosInstance.get(`/IdentityXServices/rest/v1/.well-known/jwks.json`)
}